// extracted by mini-css-extract-plugin
export var cancelButton = "_og-5";
export var content = "_og-3";
export var createButton = "_og-6";
export var drawerContainer = "_og-0";
export var footer = "_og-2";
export var header = "_og-1";
export var orderFormColumn = "_og-4";